const messages: Record<string, string> = {
	'loader.loading': 'Ładowanie danych ...',
	'loader.error': 'Polisa nie może zostać załadowana. Spróbuj później...',
	'connectionError.title': 'Błąd połączenia',
	'connectionError.description': 'Błąd połączenia. Wyślij zdjęcie ponownie.',
	'mainError.tryAgain': 'Spróbuj ponownie',
	'landing.headline.policyCheck': 'INSPEKCJA POJAZDU',
	'landing.stepDescription.fourAdditionalPictures': 'Prześlij zdjęcia',
	'landing.stepDescription.fourDiagonalPerspectives': 'Zrób zdjęcia',
	'landing.stepDescription.vehicleInformation': 'Wpisz dane pojazdu',
	'landing.stepDescription.feedback': 'Podziel się swoją opinią',
	termsAndConditionsLinkDescription: 'Aby rozpocząć, zaakceptuj regulamin i kliknij „Dalej”.',
	termsAndConditionsLink: 'Zaakceptuj regulamin',
	'button.next': 'Dalej',
	'button.start': 'Rozpocznij inspekcję',
	'button.close': 'Zamknij',
	'landing.aboutPolicyCheck': 'Czym jest inspekcja pojazdu?',
	'tutorialModal.headline.first.policyCheck': 'Czym jest inspekcja pojazdu?',
	'tutorialModal.paragraph.first.policyCheck':
		'<b>Inspekcja pojazdu</b> to aplikacja, w której zbieramy zdjęcia Twojego pojazdu ubezpieczonego w UNIQA.',
	'chooseLang.headline': 'Wybierz język',

	'menuSteps.stepName.FourDiagonalPerspectives': 'Zdjęcia pojazdu',
	'menuSteps.stepName.FourAdditionalPictures': 'Zdjęcia szczegółów',
	'menuSteps.stepName.Review': 'Podsumowanie',

	'vehicleImages.overviewPhotos': 'Zdjęcia pojazdu',
	'vehicleImages.overviewPhotos.subtitle': ' ',
	'vehicleImages.description':
		'Zrób zdjęcia pojazdu tak, aby było widać elementy wymienione w każdej sekcji. Staraj się zmieścić w kadrze cały pojazd.',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': 'Lewa przednia strona pojazdu',
	'four-diagonal-perspectives-vehicle-front-left-description': 'Zobacz przykładowe zdjęcie',
	'fourDiagonalPerspectives.addPhoto': 'Dodaj zdjęcie',
	'button.backchangeImage': 'Zmień zdjęcie',
	'fourDiagonalPerspectives.vehicleRearLeft.title': 'Lewa tylna strona pojazdu',
	'fourDiagonalPerspectives.vehicleRearRight.title': 'Prawa tylna strona pojazdu',
	'fourDiagonalPerspectives.vehicleFrontRight.title': 'Prawa przednia strona pojazdu',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Przykładowe zdjęcie',

	'imageRecognitionMismatchModal.headline':
		'<b>Sprawdź, czy zdjęcia odpowiadają wymaganiom w opisie. Jeśli tak, to kontynuuj.</b><br><br>Jeśli dodasz niewłaściwe zdjęcia, inspekcja może się nie udać i konieczne będzie ponowne zrobienie zdjęć.',
	'button.continue': 'Dalej ➔',

	'fourPerspectivesExampleModal.headline.first': 'Zdjęcia poglądowe pojazdu – przykład',
	'fourPerspectivesExampleModal.button.close': 'Zamknij',

	'vehicleImages.leftFrontOverview': 'Zdjęcie pojazdu z przodu, z lewej strony',
	'vehicleImages.rightFrontOverview': 'Zdjęcie pojazdu z przodu, z prawej strony',
	'vehicleImages.leftRearOverview': 'Zdjęcie pojazdu z tyłu, z lewej strony',
	'vehicleImages.rightRearOverview': 'Zdjęcie pojazdu z tyłu, z prawej strony',
	'button.changeImage': 'Zmień zdjęcie',
	'button.deleteImage': 'Usuń zdjęcie',

	'completeVehicleImagesModal.headline': 'Dodaj następujące zdjęcia:',
	'completeVehicleImagesModal.description': ' ',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'Zdjęcie pojazdu z przodu z lewej strony',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'Zdjęcie pojazdu tyłu z lewej strony',
	'completeVehicleImagesModal.hasVehicleImageFrontRight':
		'Zdjęcie pojazdu z przodu z prawej strony',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Zdjęcie pojazdu z tyłu z prawej strony',

	'fourAdditionalPictures.title': 'Zdjęcia szczegółów',
	'fourAdditionalPictures.overallDashboard.title': 'Wnętrze pojazdu',
	'fourAdditionalPictures.overallDashboard.description':
		'Zrób zdjęcie wnętrza pojazdu przez otwarte drzwi kierowcy, tak aby deska rozdzielcza była widoczna.',
	'fourAdditionalPictures.mileage.title': 'Przebieg',
	'fourAdditionalPictures.mileage.description':
		'Zrób zdjęcie przebiegu. Jeśli masz elektroniczny wyświetlacz, włącz go.',
	'fourAdditionalPictures.mileage.enter': 'Wprowadź przebieg pojazdu',
	'dashboardMileage.placeholder': '000000',
	'fourAdditionalPictures.windshield.title': 'Przednia szyba pojazdu',
	'fourAdditionalPictures.windshield.description': 'Zrób dokładne zdjęcie przedniej szyby.',

	'fourAdditionalPictures.vin.description':
		'Zrób zdjęcie numeru VIN. Możesz go znaleźć na krawędzi drzwi lub w lewym dolnym rogu przedniej szyby. Nie rób zdjęcia VIN-u z dowodu rejestracyjnego. Potrzebny jest numer widniejący na samochodzie.',

	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle':
		'Przykładowe zdjęcie lewej, przedniej strony pojazdu',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle':
		'Przykładowe zdjęcie prawej, przedniej strony pojazdu',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle':
		'Przykładowe zdjęcie lewej, tylnej strony pojazdu',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle':
		'Przykładowe zdjęcie prawej, tylnej strony pojazdu',
	'fourAdditionalPictures.vin.exampleModalTitle': 'Przykładowe zdjęcie numeru VIN',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Przykładowe zdjęcie przebiegu',
	'overallDashboardImage.title': 'Całościowe zdjęcie deski rozdzielczej',
	'dashboardMileage.dashboard.title': 'Zdjęcie przebiegu',
	'windshieldImage.title': 'Zdjęcie przedniej szyby',
	'vinPicture.title': 'Zdjęcie numeru VIN',
	'dashboardMileage.dashboard.paragraph':
		'Zrób zdjęcie deski rozdzielczej z wyświetlonym przebiegiem. Jeśli w pojeździe są wyświetlacze elektroniczne, włącz je.   ',

	'completeFourAdditionalPicturesModal.headline': 'Podpowiedź',
	'completeFourAdditionalPicturesModal.description': 'Dodaj poniższe informacje:',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage': 'Zdjęcie deski rozdzielczej',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Zdjęcie przebiegu',
	'completeDashboardMileageModal.hasValidMileage': 'Przebieg',
	'completeFourAdditionalPicturesModal.hasVINImage': 'Zdjęcie numeru VIN',
	'completeFourAdditionalPicturesModal.hasWindshieldImage': 'Zdjęcie przedniej szyby',

	'feedback.headline.policyCheck':
		'W imieniu UNIQA dziękujemy za skorzystanie z aplikacji PolicyCheck!',
	'feedback.description':
		'Mamy nadzieję, że jesteś zadowolony z naszych usług. Czekamy na Twoją opinię.',
	'feedback.rating.policyCheck': 'Jak oceniasz zgłoszenie inspekcji przez aplikację PolicyCheck?',
	'feedback.yourOpinion': 'Twoja opinia',
	'feedback.button.send': 'Wyślij opinię',

	'thanks.headline.first': 'Dziękujemy',
	'waitForAudit.description.damageFound':
		'Następny krok należy do nas. W razie potrzeby skontaktujemy się z Tobą.',

	'vehicleInformation.headline.first': 'Informacje na temat pojazdu',
	'vehicleInformation.headline.fourth': 'Zdjęcie dowodu rejestracyjnego (tył)',
	'vehicleInformation.headline.second': 'Zdjęcie dowodu rejestracyjnego (przód)',
	'vehicleInformation.paragraph.first':
		'Dodaj zdjęcie dowodu rejestracyjnego (przód). Jeśli nie masz jeszcze dowodu rejestracyjnego, możesz przesłać tymczasowy dowód rejestracyjny, umowę kupna lub fakturę pojazdu.',
	'vehicleInformation.paragraph.fourth':
		'Dodaj zdjęcie dowodu rejestracyjnego  (tył). Jeśli nie masz jeszcze dowodu rejestracyjnego, możesz przesłać tymczasowy dowód rejestracyjny, umowę kupna lub fakturę pojazdu.',

	'tutorialModal.paragraph.second': ' ',

	'landing.additional-informations-section.title':
		'W ramach inspekcji prosimy Cię o wykonanie kilku zdjęć pojazdu. Nie zajmie to dłużej niż 10 minut.',
	'landing.additional-informations-section.text': ' ',

	'landing.termsAndConditionsLinkDescription': 'Aby rozpocząć kliknij Dalej',

	'damageImages.headline': 'Zdjęcia uszkodzeń (opcjonalne)',
	'damageImages.additionalImages':
		'Zrób zdjęcia uszkodzeń pojazdu i dodaj je poniżej. Możesz dodać maks. 4 zdjęcia.',
	'damageImages.optionalDamageImages': 'Zdjęcia uszkodzenia',

	'timeout.bottom': ' ',
	'timeout.headline.first': 'Link jest nieaktywny.',
	'timeout.paragraph.first': 'W razie potrzeby skontaktujemy się z Tobą.',

	'review.button.next': 'Prześlij zdjęcia do inspekcji',
	'review.stepDescription.fourDiagonalPerspectives': 'Zdjęcia pojazdu',
	'review.stepDescription.fourAdditionalPictures': 'Zdjęcia szczegółów',
	'review.stepDescription.damageImages': 'Zdjęcia uszkodzeń',

	'invalidFile.size.title': 'Nieprawidłowy rozmiar pliku',
	'invalidFile.size.description': 'Zdjęcie jest większe niż maksymalny dozwolony rozmiar.',
	'invalidFile.extension.title': 'Plik ma niewłaściwy format',
	'invalidFile.extension.description':
		'Załadowany plik ma niewłaściwy format. Pliki obsługiwane przez aplikację to: .jpg, .jpeg, .jfif, .heic, .heif, .png oraz .bmp.',

	'blockedByDevice.description':
		'Strona została otwarta z wykorzystaniem przeglądarki na komputerze.\r\nPlatforma PolicyCheck dedykowana jest do dokumentowania\r\npojazdu za pomocą urządzeń mobilnych.\r\n\r\nUruchom link na urządzeniu mobilnym aby kontynuować.\r\n\r\nJeśli korzystasz z urządzenia mobilnego, sprawdź w ustawieniach przeglądarki, czy nie jest włączona opcja „Wersja na komputer”. W razie potrzeby wyłącz ją i ponownie otwórz stronę.',
};

export default messages;
